
const stringyfyVariants = (variants) => {
  if (!variants) return null
  return Object.keys(variants)
    .map((key) => `${key} ${variants[key]}`)
    .join(' - ')
}

export const getInfos = (product) => {
  const infos = []
  !!product?.selectedVariants &&
    infos.push(stringyfyVariants(product.selectedVariants))
  !!product?.color && infos.push(product.color)
  return infos.join(' - ')
}

export default {
  name: 'CartExerptProduct',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    infos() {
      return getInfos(this.product)
    }
  },
  methods: {
    updateQuantity(e) {
      const cartQuantity = parseInt(e.target.value)
      this.$store.commit('cart/setItemQuantity', {
        itemId: this.product.id,
        cartQuantity
      })
    }
  }
}
